import React from 'react';
import { directRequire } from 'js/backbone/portlets';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';

class BonusMultiviewPageViewWrapper extends React.Component {
    componentDidMount() {
        const [importComponent] = directRequire(['portlets_bonus_multiview_bonus_multiview_model']);

        importComponent().then(({ default: Model }) => {
            const model = new Model({ config: this.props.config, ...this.props.config }, { parse: true });

            this.view = model.getView();
            this.view.setElement(this.el);
            this.view.render();
            this.view.portletDidMount();
        });
    }

    componentWillUnmount() {
        this.view && this.view.close();
    }

    render() {
        return <BackboneWrapper el={el => this.el = el} />;
    }
}

const BonusMultiviewPageView = () => {
    const config = usePortletConfig();

    return <BonusMultiviewPageViewWrapper config={config} />;
};

export default withPortlet()(BonusMultiviewPageView);
